// import React, { Fragment, useEffect, useMemo } from "react";
// import Editor from "../../../components/form/Editor";
// import Input from "../../../components/form/Input";
// import Select from "../../../components/form/Select";
// import useForm from "../../../hooks/useForm";
// import Button from "../../../components/form/Button";
// import useMutation from "../../../hooks/useMutation";

// import { userAddEdit } from "../../../services/userService";
// import FileUploadSingle from "../../../components/form/FileUploadSingle";
// import Tabs from "../../../components/elements/Tabs";

// const validation = {
//   firstName: { required: true, message: "First Name is required" },
//   lastName: { required: true, message: "Last Name is required" },
//   email: { required: true, message: "Email is required" },
// };

// const ManageUser = ({ getResponse = () => {}, close = () => {}, data }) => {
//   const {
//     values,
//     handleChange,
//     handleSubmit,
//     errors,
//     setFieldsValue,
//     resetField,
//     formValidate,
//   } = useForm({ validationRules: validation });

//   useEffect(() => {
//     if (data?._id) {
//       setFieldsValue({ ...data, image: data?.image?.url });
//     }
//   }, [data]);

//   const {
//     mutate,
//     error,
//     isPending: isLoading,
//   } = useMutation({
//     mutationFn: async (val) => {
//       return await userAddEdit({
//         ...val,

//         roleCode: "USER",
//         ...(data?._id && { id: data?._id }),
//       });
//     },
//     onSuccess: (res) => {
//       getResponse(res);
//       return res;
//     },
//     onError: (error) => {
//       console.log(error);
//     },
//   });

//   const tabItems = useMemo(() => {
//     const tabs = [
//       {
//         label: "Basic Info",
//         icon: "fas fa-user",
//         content: (
//           // <Cards
//           //   title="User Information"
//           //   description="Personal details & image"
//           // >
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <Input
//               label="First Name"
//               inputPlaceholder="Enter First Name"
//               inputName="firstName"
//               value={values?.firstName}
//               onChange={handleChange}
//               {...formValidate(errors, "firstName")}
//             />
//             <Input
//               label="Last Name"
//               inputPlaceholder="Enter Last Name"
//               inputName="lastName"
//               value={values?.lastName}
//               onChange={handleChange}
//               {...formValidate(errors, "lastName")}
//             />
//             <Input
//               label="Email"
//               inputPlaceholder="Enter Email"
//               inputType="email"
//               inputName="email"
//               value={values?.email}
//               isDisabled={data?._id}
//               onChange={handleChange}
//               {...formValidate(errors, "email")}
//             />
//             <Input
//               label="Phone"
//               inputPlaceholder="Enter Phone"
//               inputName="phone"
//               value={values?.phone}
//               onChange={handleChange}
//               {...formValidate(errors, "phone")}
//             />
//             <div className="col-span-full">
//               <FileUploadSingle
//                 label="User Photo"
//                 size="small"
//                 value={values?.image}
//                 onChange={(file) =>
//                   handleChange({ target: { name: "image", value: file } })
//                 }
//                 accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.tiff,.svg,image/*"
//                 {...formValidate(errors, "image")}
//               />
//             </div>
//           </div>
//           // </Cards>
//         ),
//       },
//     ];

//     // if (!data?._id) {
//     tabs.push({
//       label: "Password Setup",
//       icon: "fas fa-lock",
//       content: (
//         // <Cards title="Password Setup" description="Secure user credentials">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <Input
//             label="Password"
//             inputPlaceholder="Enter Password"
//             inputName="password"
//             inputType="password"
//             value={values?.password}
//             onChange={handleChange}
//             {...formValidate(errors, "password")}
//           />
//           <Input
//             label="Confirm Password"
//             inputPlaceholder="Enter Confirm Password"
//             inputName="confirmPassword"
//             inputType="password"
//             value={values?.confirmPassword}
//             onChange={handleChange}
//             {...formValidate(errors, "confirmPassword")}
//           />
//         </div>
//         // </Cards>
//       ),
//     });
//     // }

//     return tabs;
//   }, [values, handleChange, errors, data]);

//   return (
//     <form
//       onSubmit={(event) => handleSubmit(event, mutate)}
//       className="space-y-6"
//     >
//       <Tabs
//         defaultActiveKey={0}
//         items={tabItems}
//         tabsClass="border-b border-gray-200 space-x-6 px-4"
//       />

//       <div className="flex items-center justify-center gap-4 pt-6">
//         <Button
//           buttonType="submit"
//           buttonLabel="Save User"
//           buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
//           buttonLabelClasses="mx-auto"
//           {...(isLoading && {
//             loading: true,
//             buttonIconPosition: "left",
//             isDisable: true,
//           })}
//         />
//         <Button
//           buttonLabel="Cancel"
//           buttonFunction={close}
//           buttonClasses="!rounded-full !px-8 !h-12 !border !border-gray-400 !bg-transparent !text-gray-600 hover:!bg-gray-200"
//           buttonLabelClasses="mx-auto"
//         />
//       </div>
//     </form>
//   );
// };

// export default ManageUser;

//code from reactBase
import { useQuery } from "@tanstack/react-query";

// import AdvanceSettings from "./AdvanceSettings.js";

import UserProfile from "./UserProfile.js";

import Tabs from "../../../components/elements/Tabs";
import { userDetails } from "../../../services/userService.js";
import { initialsValue } from "../../../helpers/index.js";
import Indentification from "../../../components/elements/Indentification.js";
import Plans from "../plans/Plans.js";
import UserAddress from "./UserAddress.js";
import Transaction from "../transaction/Transaction.js";
import useFetch from "../../../hooks/useFetch.js";
import Subscription from "../subscription/Subscription.js";
import Orders from "../order/Orders.js";

const ManageUser = ({
  getResponse = () => {},
  close = () => {},
  data,
  selectedTab,
  setSelectedTab = () => {},
}) => {
  const {
    data: details,
    error,
    isLoading: detailsLoading,
    updateData,
    isFetching: detailsFetching,
    refetch,
  } = useFetch({
    dependencies: ["user-details", data?._id],
    fetchFunction: async () => {
      const res = await userDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  const tabs = [
    {
      label: "User Profile",
      icon: "fa-light fa-user",
      content: (
        <UserProfile
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      ),
      // content: <div className="relative">User's Content</div>,
    },
    // {
    //   label: "Advance Settings",
    //   icon: "fa-light fa-gear",
    //   type: "image",
    //   // content: (
    //   //   <AdvanceSettings
    //   //     details={details}
    //   //     getResponse={getResponse}
    //   //     loading={detailsLoading || detailsFetching}
    //   //   />
    //   // ),
    //   content: <div className="relative">User's Password</div>,
    // },

    {
      label: "Address",
      icon: "fa-solid fa-location-dot",
      type: "image",
      content: (
        <UserAddress
          addresses={Array.isArray(details?.address) ? details?.address : []}
        />
      ),
      // content: <div className="relative">Address Plans</div>,
    },
    {
      label: "Subscription",
      icon: "fa-solid fa-money-check-dollar",
      type: "image",
      content: <Subscription userId={details?._id} />,
      // content: <div className="relative">User's Plans</div>,
    },
    {
      label: "Transaction",
      icon: "fa-light fa-hand-holding-dollar",
      type: "image",
      content: <Transaction userId={details?._id} />,
      // content: <div className="relative">User's Transaction</div>,
    },
    {
      label: "Orders",
      icon: "fa-solid fa-box",
      type: "image",
      content: <Orders userId={details?._id} />,
    },

    // {
    //   label: "Activity logs",
    //   icon: "fa-solid fa-list-timeline",
    //   type: "image",
    //   content: <div className="relative">Activity logs</div>,
    // },
  ];

  const name = data?.firstName + " " + data?.lastName;

  return (
    <div className="px-6 mt-4 h-full">
      {data?._id && (
        <div className="flex items-center font-medium text-xl text-slate-600">
          <span className="text-[18px] text-slate-400">Users /</span>
          <div className="relative flex items-center ml-2">
            <Indentification
              initial={initialsValue(name)}
              image={data?.image?.url}
              alt={name}
              fill={true}
              className=""
              size="md"
            />
            <div className="text-md mx-2">{name}</div>
          </div>
        </div>
      )}

      <div className="mt-4 relative">
        <Tabs
          items={tabs}
          selectedIndex={selectedTab}
          setSelectedIndex={setSelectedTab}
        />
      </div>
    </div>
  );
};

export default ManageUser;
